/* eslint-disable */
/**
 * tslint:disable
 * Generated by orval 🍺
 * Do not edit manually.
 * Parcelshop locator
 */
import { useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { GetParcelShopLocationsCountrycodeParams, ParcelShopLocationDto } from './index.schemas'

import { client } from '../mutator/client'
import type { ErrorType } from '../mutator/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Search by a specific servicepoint ID. Note that there are shops returned which may be closed, refer to closurePeriods for more information.
 */
export const getParcelShopLocationsCountrycodeId = (
  countryCode: string,
  id: string,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal
) => {
  return client<ParcelShopLocationDto>(
    { url: `/parcel-shop-locations/${countryCode}/${id}`, method: 'GET', signal },
    options
  )
}

export const getGetParcelShopLocationsCountrycodeIdQueryKey = (countryCode?: string, id?: string) => {
  return [`/parcel-shop-locations/${countryCode}/${id}`] as const
}

export const getGetParcelShopLocationsCountrycodeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>, TError, TData>>
    request?: SecondParameter<typeof client>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetParcelShopLocationsCountrycodeIdQueryKey(countryCode, id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>> = ({ signal }) =>
    getParcelShopLocationsCountrycodeId(countryCode, id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!(countryCode && id), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopLocationsCountrycodeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>
>
export type GetParcelShopLocationsCountrycodeIdQueryError = ErrorType<string | null | null | null>

export function useGetParcelShopLocationsCountrycodeId<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
          TError,
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopLocationsCountrycodeId<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
          TError,
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopLocationsCountrycodeId<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>, TError, TData>>
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShopLocationsCountrycodeId<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycodeId>>, TError, TData>>
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetParcelShopLocationsCountrycodeIdQueryOptions(countryCode, id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Search by a full query. Note that there are shops returned which may be closed, refer to closurePeriods for more information.
 */
export const getParcelShopLocationsCountrycode = (
  countryCode: string,
  params?: GetParcelShopLocationsCountrycodeParams,
  options?: SecondParameter<typeof client>,
  signal?: AbortSignal
) => {
  return client<ParcelShopLocationDto[]>(
    { url: `/parcel-shop-locations/${countryCode}`, method: 'GET', params, signal },
    options
  )
}

export const getGetParcelShopLocationsCountrycodeQueryKey = (
  countryCode?: string,
  params?: GetParcelShopLocationsCountrycodeParams
) => {
  return [`/parcel-shop-locations/${countryCode}`, ...(params ? [params] : [])] as const
}

export const getGetParcelShopLocationsCountrycodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  params?: GetParcelShopLocationsCountrycodeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>, TError, TData>>
    request?: SecondParameter<typeof client>
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetParcelShopLocationsCountrycodeQueryKey(countryCode, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>> = ({ signal }) =>
    getParcelShopLocationsCountrycode(countryCode, params, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!countryCode, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopLocationsCountrycodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>
>
export type GetParcelShopLocationsCountrycodeQueryError = ErrorType<string | null | null | null>

export function useGetParcelShopLocationsCountrycode<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  params: undefined | GetParcelShopLocationsCountrycodeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
          TError,
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopLocationsCountrycode<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  params?: GetParcelShopLocationsCountrycodeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
          TError,
          Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopLocationsCountrycode<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  params?: GetParcelShopLocationsCountrycodeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>, TError, TData>>
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShopLocationsCountrycode<
  TData = Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>,
  TError = ErrorType<string | null | null | null>,
>(
  countryCode: string,
  params?: GetParcelShopLocationsCountrycodeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getParcelShopLocationsCountrycode>>, TError, TData>>
    request?: SecondParameter<typeof client>
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetParcelShopLocationsCountrycodeQueryOptions(countryCode, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}
